import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

interface data {
  name: string | undefined | boolean;
}

export default function NavBar({ name }: data) {
  const navigate = useNavigate();

  const displayName =
    typeof name === "string"
      ? name.length > 16
        ? name.substring(0, 16) + "..."
        : name
      : name;
  return (
    <nav className="flex justify-between p-2 bg-white border-b">
      <div className="flex justify-start">
        <button type="button" onClick={() => navigate(-1)}>
          <div className="flex">
            <div className="my-auto">
              <FaArrowRight />
            </div>
            <p className="mr-2 text-sm">{displayName}</p>
          </div>
        </button>
      </div>
      {/* <Logout /> */}
    </nav>
  );
}
